module.exports = __webpack_public_path__ + "img/Girl_010000.2ce9f71b.png";